import { GzPaginationWebComponent } from './component/GzPaginationWebComponent';
import { WEB_COMPONENT_GZ_PAGINATION } from '../../../webcomponents.constants';

export { GzPaginationWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_PAGINATION, GzPaginationWebComponent);
